export default __webpack_public_path__ + "static/media/logo.1ef94a7b.jpg";